import { BdResourceSorting } from '@bindoc-projects/resource-domain-lib';

export const BD_RESOURCES_DEFAULT_SORTING: BdResourceSorting = {
  field: 'modifiedDate',
  desc: true,
};
